import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { createModal } from "react-modal-promise";

interface Props {
  message: string;
  title: string;
  // open and close are given via react-modal-promise HOC
  open: boolean;
  close: () => void;
}
type PropsWithNamespaces = Props & WithNamespaces;

class CommentAlertModal extends React.Component<PropsWithNamespaces, {}> {

  /**
   * Transmit modal result while closing it
   */


  render() {
    /* This modal should be in a promise, so it's always open */
    return (
      <Modal
        isOpen={this.props.open}
        toggle={this.props.close}
        className="comment-modal"
      >
        <ModalHeader toggle={this.props.close}>
          <span className="flex-1">{this.props.title}</span>
        </ModalHeader>
        <ModalBody>
          <p>{this.props.message}</p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={this.props.close}
          >
            {this.props.t("commentModal.validate")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default createModal(withNamespaces()(CommentAlertModal));



// WEBPACK FOOTER //
// ./src/components/CommentAlertModal.tsx